import axios from 'axios';
//checktest1test1
const jwtAxios = axios.create({
  //local api
  // baseURL: 'http://localhost:8080/api/',
  //baseURL:"https://sarvodayademo.gudmed.in",
  //test api
  // baseURL: 'https://apitest.gudmed.in/api/',
  //baseURL: 'https://sarvodayaapi.gudmed.in/api/',
  //live api
  //   baseURL: 'https://apilive.gudmed.in/api/',
  baseURL: 'https://apidev.gudmed.in/api/',
  //baseURL: 'https://apiuat.gudmed.in/api/',
  // baseURL: 'https://gudmeddevapi.gudmed.in/api/',

  headers: {
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
    'Content-Type': 'application/json',
  },
  validateStatus: function (status) {
    return status >= 200 && status < 400;
  },
});
jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.data.msg === 'Token is not valid') {
      // store.dispatch({type: LOGOUT});
    }
    return Promise.reject(err);
  },
);
export const setAuthToken = (token) => {
  if (token) {
    jwtAxios.defaults.headers.common['x-auth-token'] = token;
    localStorage.setItem('token', token);
  } else {
    delete jwtAxios.defaults.headers.common['x-auth-token'];
    localStorage.removeItem('token');
  }
};

export default jwtAxios;
